export default "__VITE_PUBLIC_ASSET__1afd7f2b__"